function sanitizePhone(e){return(e||"").toString().replace(/[^0-9]/gi,"")}export{sanitizePhone};
//# sourceMappingURL=sanitize.js.map
